import { render, staticRenderFns } from "./UserSelectMultiple.vue?vue&type=template&id=220f6f8c&"
import script from "./UserSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./UserSelectMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports